export default __webpack_public_path__ + "static/media/global.e4242672.svg";